module.exports = __webpack_public_path__ + "static/story3-social-1200x630-c32993fc038a9ab7207233f58db16c50.jpg";